<template>
    <div class="">
        <div>
            <!-- Contact Open Time -->
            <floating-input id="door_open_time"
                            label="Door Open Time (Minutes)"
                            v-model:value="doorOpenTime"
            ></floating-input>

            <!-- Total Time Tracked -->
            <floating-input id="door_status_look_behind"
                            label="Door Status Look Behind (Minutes)"
                            v-model:value="doorStatusLookBehind"
            ></floating-input>

            <!-- Value for Door when Open -->
            <div    class="flex flex-col">
                <span>Value on Closure when the door is open.</span>
                <span class="relative z-0 inline-flex shadow-sm rounded-md">
                    <button     type="button"
                                class="relative inline-flex items-center px-4 py-2 rounded-l-md bg-white text-sm font-medium hover:bg-gray-50 focus:z-10 "
                                :class="[doorOpenValue === '0' ? 'border-2 border-blue-300 text-blue-700' : 'border border-gray-300 text-gray-700']"
                                @click="updateDoorOpenValue('0')"
                    >
                        0
                    </button>
                    <button     type="button"
                                class="relative inline-flex items-center px-4 py-2 rounded-r-md bg-white text-sm font-medium hover:bg-gray-50 focus:z-10 "
                                :class="[doorOpenValue === '1' ? 'border-2 border-blue-300 text-blue-700' : 'border border-gray-300 text-gray-700']"
                                @click="updateDoorOpenValue('1')"
                    >
                        1
                    </button>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
import {iconNamesMixin} from '@/mixins/IconNamesMixin';
import FloatingInput from "@/components/elements/FloatingInput";

const HANDLER_NAME = 'Door-Status Dependent Pressure Alarms'

export default {
    name: "AlarmHandlerPressureWithDoorStatus",
    mixins: [SonicuCoreMixin, iconNamesMixin],
    components: {FloatingInput},
    emits: ['update:modelValue',],
    compatConfig: { COMPONENT_V_MODEL: false },
    props: {
        modelValue: Object,
    },
    data() {
        return {
            doorOpenTime: '2',
            doorStatusLookBehind: '15',
            doorOpenValue: '0',
        }
    },
    created() {
    },
    mounted() {
        this.doorOpenTime = this.modelValue.doorOpenTime
        this.doorStatusLookBehind = this.modelValue.doorStatusLookBehind
        this.doorOpenValue = this.modelValue.doorOpenValue
    },
    methods: {
        updatemodelValue(tmp) {
            if (!tmp) {
                tmp = this.modelValue
                tmp.handler = HANDLER_NAME
                tmp.doorOpenTime = this.doorOpenTime
                tmp.doorStatusLookBehind = this.doorStatusLookBehind
                tmp.doorOpenValue = this.doorOpenValue
            }

            this.$emit('update:modelValue', tmp)
        },
        updateDoorOpenValue(val) {
            this.doorOpenValue = val
        },
    },
    computed: {},
    watch: {
        modelValue(val, old) {
            if (_.isNil(val)) {
                return
            }
            this.doorOpenTime = val.doorOpenTime
            this.doorStatusLookBehind = val.doorStatusLookBehind
            this.doorOpenValue = val.doorOpenValue
        },
        doorOpenTime(val, old) {
            if (val === this.modelValue.doorOpenTime) {
                return
            }
            this.updatemodelValue()
        },
        doorStatusLookBehind(val, old) {
            if (val === this.modelValue.doorStatusLookBehind) {
                return
            }
            this.updatemodelValue()
        },
        doorOpenValue(val, old) {
            if (val === this.modelValue.doorOpenValue) {
                return
            }
            this.updatemodelValue()
        },
    },
}
</script>

<style scoped>

</style>